module.exports = __webpack_public_path__ + "media/images/emblems/Schuepfen-coat_of_arms-d6bcb6029e3366617b1373b145f7b721.svg";